import React from "react";
import { Container, Title, SectionTitle, Paragraph, Link } from "./PrivacyPolicyStyles";

const PrivacyPolicy: React.FC = () => {
  return (
    <Container>
      <Title>Política de Privacidade</Title>

      <SectionTitle>1. Introdução</SectionTitle>
      <Paragraph>
        Nós respeitamos a sua privacidade e estamos comprometidos em protegê-la. Este documento
        explica nossa política de privacidade, descrevendo como lidamos com informações no nosso
        aplicativo.
      </Paragraph>

      <SectionTitle>2. Coleta de Dados Pessoais</SectionTitle>
      <Paragraph>
        Coletamos dados pessoais fornecidos voluntariamente pelo usuário para a realização de
        pagamentos, como nome completo, CPF, e-mail e dados do cartão de crédito. O CPF é
        armazenado de forma criptografada e os dados do cartão são tratados com segurança por
        nossos parceiros de pagamento, sem serem armazenados diretamente por nós.
      </Paragraph>

      <SectionTitle>3. Dados de Pagamento e Transações</SectionTitle>
      <Paragraph>
        Para viabilizar os pagamentos no aplicativo, coletamos e processamos informações de
        pagamento através de parceiros confiáveis, como Cielo. Esses dados incluem valor da
        transação, data, método de pagamento e status. Nenhum dado sensível do cartão (como
        número completo, CVV) é armazenado por nós.
      </Paragraph>

      <SectionTitle>4. Dados de Uso</SectionTitle>
      <Paragraph>
        Não coletamos informações sobre o uso do aplicativo, como preferências, frequência de uso
        ou outras interações. O aplicativo opera de forma independente, sem necessidade de login
        ou coleta de dados.
      </Paragraph>

      <SectionTitle>5. Cookies e Tecnologias Semelhantes</SectionTitle>
      <Paragraph>
        Nosso aplicativo não utiliza cookies, rastreadores ou tecnologias semelhantes para
        monitorar o comportamento do usuário.
      </Paragraph>

      <SectionTitle>6. Compartilhamento de Dados com Terceiros</SectionTitle>
      <Paragraph>
        Podemos compartilhar dados com terceiros estritamente necessários para a execução dos
        serviços, como intermediadores de pagamento e serviços antifraude. Esses terceiros são
        obrigados a tratar os dados conforme exigido pela legislação aplicável, garantindo a
        segurança e confidencialidade.
      </Paragraph>

      <SectionTitle>7. Alterações nesta Política de Privacidade</SectionTitle>
      <Paragraph>
        Podemos atualizar esta Política de Privacidade periodicamente. Quaisquer alterações serão
        publicadas nesta página, e encorajamos os usuários a revisar esta política regularmente.
      </Paragraph>

      <SectionTitle>8. Contato</SectionTitle>
      <Paragraph>
        Se você tiver alguma dúvida sobre esta Política de Privacidade ou sobre o uso do
        aplicativo, entre em contato conosco pelo site:{" "}
        <Link href="https://elementalsistemas.com.br/" target="_blank" rel="noopener noreferrer">
          https://elementalsistemas.com.br/
        </Link>
      </Paragraph>
    </Container>
  );
};

export default PrivacyPolicy;
